import { Form, Input } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { MarkdownDescription } from 'app/components/commons/MarkdownDescription/MarkdownDescription';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

export const Description = () => {
  const { isEditMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();
  const descriptionValue = Form.useWatch('description', form);

  return (
    <FormLineLayout
      label={<MarkdownDescription label="Description" />}
      labelOnTop
      rightClassName="copywriting-form"
    >
      <Form.Item name="description">
        {isEditMode ? (
          <Input.TextArea rows={2} />
        ) : (
          <span className="view-data">
            {descriptionValue ? descriptionValue : 'ø empty'}
          </span>
        )}
      </Form.Item>
    </FormLineLayout>
  );
};
